module.exports = __webpack_public_path__ + "img/bepreisung_5_3.b0ed37a0.png";